<label #labelWrapper class="form-field" [class.with-label]="label" [class.form-field-entered]="hasValue()">
  <div class="input-wrapper">
    <ng-content select="input"></ng-content>

    @if (label) {
      <span class="form-field-label" [class.form-field-label_shrinked]="hasValue()">
        {{ label }}
      </span>
    }

    <div class="right-icon">
      <ng-container *ngTemplateOutlet="rightIcon()"></ng-container>
    </div>

    <div class="left-icon">
      <ng-container *ngTemplateOutlet="leftIcon()"></ng-container>
    </div>
  </div>

  <span class="form-field-comment">{{ error || comment }}</span>
</label>
